module.exports = __webpack_public_path__ + "static/media/slide-2.48d0c9cb.jpg";